const authKeyCloak = {
  Administrador: [
    {
      id: 'menu-monitoreo',
      title: 'Dashboard',
      // translate: 'Monitoreo',
      type: 'collapse',
      icon: 'heroicons-outline:adjustments',
      url: 'dashboard',
      children: [
        {
          id: 'menu-dashboard',
          title: 'Dashboard',
          // translate: 'Dashboard',
          type: 'item',
          icon: 'heroicons-outline:chart-square-bar',
          url: 'dashboard',
        },
        {
          id: 'menu-admin-monitoreo',
          title: 'Monitoreo',
          // translate: 'Monitoreo',
          type: 'item',
          icon: 'heroicons-outline:stop',
          url: 'monitoreo',
        },
        {
          id: 'menu-tabla-monitoreo',
          title: 'Información de Nodos',
          // translate: 'Monitoreo',
          type: 'item',
          icon: 'heroicons-outline:document-report',
          url: 'monitoreo_tabla',
        },
        {
          id: 'graficas-desempeno',
          title: 'Graficas de desempeño',
          type: 'item',
          icon: 'heroicons-outline:presentation-chart-bar',
          url: 'graficasDesempeno',
        },
        {
          id: 'menu-monitoreo-solarwinds',
          title: 'SolarWinds',
          // translate: 'Monitoreo',
          type: 'item',
          icon: 'heroicons-outline:chip',
          url: 'https://monitor.bestel.com.mx/',
          custom: 'true',
        },
      ],
    },
    {
      id: 'menu-mesa',
      title: 'Mesa de Servicio',
      // translate: 'Mesa_de_Servicio',
      type: 'collapse',
      icon: 'heroicons-outline:phone',
      url: 'mesa',
      children: [
        {
          id: 'menu-mesa-dashboard',
          title: 'Dashboard',
          // translate: 'Monitoreo',
          type: 'item',
          icon: 'heroicons-outline:template',
          url: 'mesa',
        },
        {
          id: 'menu-mesa-reports',
          title: 'Reportes',
          // translate: 'Monitoreo',
          type: 'item',
          icon: 'heroicons-outline:chart-bar',
          url: 'mesa_reportes',
        },
        {
          id: 'menu-helix-ingenieria',
          title: 'Helix Ingenieria',
          // translate: 'Monitoreo',
          type: 'item',
          icon: 'heroicons-outline:chip',
          url: 'https://cicbestel-smartit.onbmc.com/',
          custom: 'true',
        },
        {
          id: 'menu-helix-usuarios',
          title: 'Helix Usuarios',
          // translate: 'Monitoreo',
          type: 'item',
          icon: 'heroicons-outline:chip',
          url: 'https://chi-rsso1.onbmc.com/rsso/start?bypass-auth=true&tenant=cicbestel-prod&goto=https://cicbestel.onbmc.com',
          custom: 'true',
        },
      ],
    },
    {
      id: 'menu-reportes',
      title: 'Reportes',
      type: 'item',
      icon: 'heroicons-outline:folder-open',
      url: 'reportes',
    },
    {
      id: 'menu-repositorio',
      title: 'Repositorio',
      type: 'item',
      icon: 'heroicons-outline:database',
      url: 'repositorio',
    },
    {
      id: 'menu-niveles-servicio',
      title: 'Niveles de Servicio',
      type: 'collapse',
      icon: 'heroicons-outline:trending-up',
      url: 'estadisticas',
      children: [
        {
          id: 'menu-niveles-tickets',
          title: 'Estadísticas',
          type: 'item',
          icon: 'heroicons-outline:document-report',
          url: 'estadisticas',
        },
      ],
    },
    {
      id: 'menu-catalogos',
      title: 'Catálogos',
      type: 'collapse',
      icon: 'heroicons-outline:catalogue',
      url: 'sitios',
      children: [
        {
          id: 'menu-niveles-catalogo-sitios',
          title: 'Sitios',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'sitios',
        },
        {
          id: 'menu-niveles-catalogo-sitios',
          title: 'Nodos',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'nodos',
        },
        {
          id: 'menu-niveles-catalogo-entidad',
          title: 'Entidad',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'entidad',
        },
        {
          id: 'menu-niveles-catalogo-inmueble',
          title: 'Inmueble',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'inmueble',
        },
        {
          id: 'menu-niveles-catalogo-grupoInmueble',
          title: 'Grupo Inmueble',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'grupoInmueble',
        },
        {
          id: 'menu-niveles-catalogo-tipoInmueble',
          title: 'Tipo de Inmueble',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'tipoInmueble',
        },
        {
          id: 'menu-niveles-catalogo-region',
          title: 'Region',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'region',
        },
        {
          id: 'menu-niveles-catalogo-tiposConsumo',
          title: 'Tipo de Consumo',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'tiposConsumo',
        },
        {
          id: 'menu-niveles-catalogo-umbral',
          title: 'Umbral',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'umbral',
        },
      ],
    },
  ],
  NOC: [
    {
      id: 'menu-monitoreo',
      title: 'Dashboard',
      // translate: 'Monitoreo',
      type: 'collapse',
      icon: 'heroicons-outline:adjustments',
      url: 'dashboard',
      children: [
        {
          id: 'menu-dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'heroicons-outline:chart-square-bar',
          url: 'dashboard',
        },
        {
          id: 'menu-admin-monitoreo',
          title: 'Monitoreo',
          type: 'item',
          icon: 'heroicons-outline:stop',
          url: 'monitoreo',
        },
        {
          id: 'menu-tabla-monitoreo',
          title: 'Información de Nodos',
          type: 'item',
          icon: 'heroicons-outline:document-report',
          url: 'monitoreo_tabla',
        },
        {
          id: 'mapa-sitios',
          title: 'Mapa Sitios',
          type: 'item',
          icon: 'heroicons-outline:globe',
          url: 'mapaSitios',
        },
        {
          id: 'graficas-desempeno',
          title: 'Graficas de desempeño',
          type: 'item',
          icon: 'heroicons-outline:presentation-chart-bar',
          url: 'graficasDesempeno',
        },
        {
          id: 'menu-monitoreo-solarwinds',
          title: 'SolarWinds',
          // translate: 'Monitoreo',
          type: 'item',
          icon: 'heroicons-outline:chip',
          url: 'https://monitor.bestel.com.mx/',
          custom: 'true',
        },
      ],
    },
    {
      id: 'menu-mesa',
      title: 'Mesa de Servicio',
      type: 'collapse',
      icon: 'heroicons-outline:phone',
      url: 'mesa',
      children: [
        {
          id: 'menu-mesa-dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'heroicons-outline:template',
          url: 'mesa',
        },
        {
          id: 'menu-mesa-reports',
          title: 'Reportes',
          type: 'item',
          icon: 'heroicons-outline:chart-bar',
          url: 'mesa_reportes',
        },
        {
          id: 'menu-helix-ingenieria',
          title: 'Helix Ingenieria',
          type: 'item',
          icon: 'heroicons-outline:chip',
          url: 'https://cicbestel-smartit.onbmc.com/',
          custom: 'true',
        },
        {
          id: 'menu-helix-usuarios',
          title: 'Helix Usuarios',
          type: 'item',
          icon: 'heroicons-outline:chip',
          url: 'https://chi-rsso1.onbmc.com/rsso/start?bypass-auth=true&tenant=cicbestel-prod&goto=https://cicbestel.onbmc.com',
          custom: 'true',
        },
      ],
    },
    {
      id: 'menu-reportes',
      title: 'Reportes',
      type: 'item',
      icon: 'heroicons-outline:folder-open',
      url: 'reportes',
    },
    {
      id: 'menu-repositorio',
      title: 'Repositorio',
      type: 'item',
      icon: 'heroicons-outline:database',
      url: 'repositorio',
    },
    {
      id: 'menu-niveles-servicio',
      title: 'Niveles de Servicio',
      type: 'collapse',
      icon: 'heroicons-outline:trending-up',
      url: 'estadisticas',
      children: [
        {
          id: 'menu-niveles-tickets',
          title: 'Estadísticas',
          type: 'item',
          icon: 'heroicons-outline:document-report',
          url: 'estadisticas',
        },
      ],
    },
    {
      id: 'menu-catalogos',
      title: 'Catálogos',
      type: 'collapse',
      icon: 'heroicons-outline:catalogue',
      url: 'sitios',
      children: [
        {
          id: 'menu-niveles-catalogo-sitios',
          title: 'Sitios',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'sitios',
        },
        {
          id: 'menu-niveles-catalogo-sitios',
          title: 'Nodos',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'nodos',
        },
        {
          id: 'menu-niveles-catalogo-entidad',
          title: 'Entidad',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'entidad',
        },
        {
          id: 'menu-niveles-catalogo-inmueble',
          title: 'Inmueble',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'inmueble',
        },
        {
          id: 'menu-niveles-catalogo-grupoInmueble',
          title: 'Grupo Inmueble',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'grupoInmueble',
        },
        {
          id: 'menu-niveles-catalogo-tipoInmueble',
          title: 'Tipo de Inmueble',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'tipoInmueble',
        },
        {
          id: 'menu-niveles-catalogo-region',
          title: 'Region',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'region',
        },
        {
          id: 'menu-niveles-catalogo-tiposConsumo',
          title: 'Tipo de Consumo',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'tiposConsumo',
        },
        {
          id: 'menu-niveles-catalogo-umbral',
          title: 'Umbral',
          type: 'item',
          icon: 'heroicons-outline:list-bullet',
          url: 'umbral',
        },
      ],
    },
    {
      id: 'menu-administracion',
      title: 'Roles y Usuarios',
      type: 'item',
      icon: 'heroicons-outline:usuarios',
      url: 'usuarios',
    },
  ],
  Monitoreo: [
    {
      id: 'menu-mesa',
      title: 'Mesa de Servicio',
      type: 'collapse',
      icon: 'heroicons-outline:phone',
      url: 'mesa',
      children: [
        {
          id: 'menu-mesa-dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'heroicons-outline:template',
          url: 'mesa',
        },
        {
          id: 'menu-mesa-reports',
          title: 'Reportes',
          type: 'item',
          icon: 'heroicons-outline:chart-bar',
          url: 'mesa_reportes',
        },
      ],
    },
    {
      id: 'menu-monitoreo',
      title: 'Monitoreo',
      type: 'collapse',
      icon: 'heroicons-outline:adjustments',
      url: 'monitoreo',
      children: [
        {
          id: 'menu-admin-monitoreo',
          title: 'Administración',
          type: 'item',
          icon: 'heroicons-outline:stop',
          url: 'monitoreo',
        },
        {
          id: 'menu-tabla-monitoreo',
          title: 'Información de Nodos',
          type: 'item',
          icon: 'heroicons-outline:chart-bar',
          url: 'monitoreo_tabla',
        },
        {
          id: 'graficas-desempeno',
          title: 'Graficas de desempeño',
          type: 'item',
          icon: 'heroicons-outline:globe',
          url: 'graficasDesempeno',
        },
        {
          id: 'menu-monitoreo-solarwinds',
          title: 'SolarWinds',
          type: 'item',
          icon: 'heroicons-outline:chip',
          url: 'https://monitor.bestel.com.mx/',
          custom: 'true',
        },
      ],
    },
    {
      id: 'menu-reportes',
      title: 'Reportes',
      //  translate: 'Reportes',
      type: 'item',
      icon: 'heroicons-outline:folder-open',
      url: 'reportes',
    },
  ],
  Usuario: [
    {
      id: 'menu-monitoreo',
      title: 'Monitoreo',
      type: 'collapse',
      icon: 'heroicons-outline:adjustments',
      url: 'monitoreo',
      children: [
        {
          id: 'menu-admin-monitoreo',
          title: 'Administración',
          type: 'item',
          icon: 'heroicons-outline:stop',
          url: 'monitoreo',
        },
        {
          id: 'menu-tabla-monitoreo',
          title: 'Información de Nodos',
          type: 'item',
          icon: 'heroicons-outline:chart-bar',
          url: 'monitoreo_tabla',
        },
        {
          id: 'graficas-desempeno',
          title: 'Graficas de desempeño',
          type: 'item',
          icon: 'heroicons-outline:globe',
          url: 'graficasDesempeno',
        },
        {
          id: 'menu-monitoreo-solarwinds',
          title: 'SolarWinds',
          type: 'item',
          icon: 'heroicons-outline:chip',
          url: 'https://monitor.bestel.com.mx/',
          custom: 'true',
        },
      ],
    },
    {
      id: 'menu-reportes',
      title: 'Reportes',
      type: 'item',
      icon: 'heroicons-outline:folder-open',
      url: 'reportes',
    },
    {
      id: 'menu-repositorio',
      title: 'Repositorio',
      type: 'item',
      icon: 'heroicons-outline:database',
      url: 'repositorio',
    },
  ],
  Init: [],
};

export default authKeyCloak;
